export default {
    loading: "Ładowanie"
}